import { Box, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { ActionButton } from "../button/ActionButton";
import { useCurrentUser } from "../../hooks/useCurrentUser";
import { useSwitchUser } from "../../hooks/useSwitchUser";
import { useToastAlert } from "../app/ToastAlert/ToastAlertProvider";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(4, 0),
    padding: theme.spacing(2),

    borderWidth: 1,
    borderStyle: "solid",
    borderColor: theme.palette.text.secondary,
    borderRadius: 6,
    backgroundColor: `${theme.palette.quote}7F`,

    [theme.breakpoints.up("md")]: {
      display: "flex",
      alignItems: "center",
    },
  },

  text: {
    color: theme.palette.secondary.main,
    fontWeight: 500,
    opacity: 0.6,
    marginBottom: theme.spacing(2),

    [theme.breakpoints.up("md")]: {
      marginBottom: 0,
      marginRight: theme.spacing(2),
    },
  },

  viewAsClient: {
    fontSize: 16,
    whiteSpace: "nowrap",
    width: "100%",

    [theme.breakpoints.up("md")]: {
      width: "inherit",
      marginLeft: theme.spacing(5),
      marginRight: theme.spacing(3),
    },
  },
}));

export default function ViewAsSampleClientBanner() {
  const s = useStyles();

  const user = useCurrentUser();

  const switchUser = useSwitchUser();
  const { showToastAlert } = useToastAlert();

  const handleViewAsClientClick = React.useCallback(() => {
    const sampleAccount = user.accounts.find((a) => a.isSample);
    if (sampleAccount) {
      switchUser(sampleAccount.id);
    } else {
      showToastAlert("error", { message: "Sample account not found" });
    }
  }, []);

  return (
    <Box className={s.root}>
      <Typography component="div" className={s.text}>
        You can use your sample client ({user.email}) to see what your clients
        will experience once they log in to your client portal
      </Typography>
      <ActionButton
        className={s.viewAsClient}
        children="View as sample client"
        onClick={handleViewAsClientClick}
      />
    </Box>
  );
}
